/**
* Scrolling Product Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scrolling Product Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */
( function( app ) {
  const COMPONENT = {

    className: 'scrolling-product-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.scrolling-product-grid .products-list__wrapper' ).on( 'scroll', function() {
        const totalWidth = $( this )[0].scrollWidth - $( this )[0].clientWidth;

        if ( $( this ).scrollLeft() >= totalWidth - 50 ) {
          $( this ).closest( '.main-flex' ).addClass( 'is-scrolled' );
        } else {
          $( this ).closest( '.main-flex' ).removeClass( 'is-scrolled' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scrolling-product-grid', COMPONENT );
} )( app );
